<template>
<div class="qq">
  <div @click="toSign">签名</div>
  <img width="100" height="100" :src="sign_img" />
  <template v-if="showSign == true">
    <div class="dialog">
        <vue-signature ref="signature1" w="300px" h="200px" style="border: #5B5A58 solid 1px;"></vue-signature>
        <div class="sign_btns">
            <div class="saveBtn" @click="save">保存</div>
            <div class="clearBtn" @click="clear">清除</div>
            <div class="cancleBtn" @click="cancleDia">取消</div>
        </div>
    </div>
  </template>
  <canvas id="canvas" width="600" height="400" style="position: absolute;top: -1000px;"></canvas>
</div>
</template>

<script>
import vueSignature from 'vue-signature'
export default {
  name: 'Signature',
  data () {
    return {
      msg: '',
      showSign:false,
      haveSign:false,
      sign_img:''
    }
  },
  methods:{
    goto(page){
        this.$router.push(page);
    },
    toSign(){
      this.showSign = true;
    },
    //保存电子签名
    save(){
      this.haveSign = false;
      var _this = this;
      var jpeg = _this.$refs.signature1.save('image/jpeg');
      // console.log('jpeg',jpeg);
      this.sign_img = jpeg;
      let param = new FormData();
      var data_blob = this.dataURItoBlob(jpeg);
      console.log('blob',data_blob);

      console.log('转化为',);
      param.append('pic_passport',data_blob,'sss.jpg');
      this.cancleDia();

      var img = new Image();
      img.onload = function () {
          var context = canvas.getContext('2d');
          // 图片绘制
          context.drawImage(img, 0, 0, 600, 400);
          // 然后获取中间100*100区域数据
          var imageData = context.getImageData(0, 0, 600, 400);
          var length = imageData.data.length;
          for (var index = 0; index < length; index += 4) {
              var r = imageData.data[index];
              var g = imageData.data[index + 1];
              var b = imageData.data[index + 2];
              // 判断是否存在写字
              if(r == 0 && g == 0 && b == 0){
                  _this.haveSign = true;
                  break;
              }
            //   console.log( r,g,b);
            }
        };
        img.src = this.sign_img;
        console.log('写字',this.haveSign,_this.haveSign);
        // 调用
        let file = this.dataURLtoFile(this.sign_img,'aaa.jpg');
        localStorage.setItem('Signature',file);
        this.savesign(file);
    },
     //毕业证书
    savesign(file){
        // this.fileAdd(file,(res)=>{
        //     var access_token = localStorage.getItem('access_token');
        //     var config = {
        //         headers:{'x-api-key':access_token,'Content-Type': 'multipart/form-data'}
        //     };
        //     var form_data = new FormData();
        //     form_data.append('sign',res);
        //     this.$request.postFile('/v1/file/cos', form_data,config, response => {
        //         if(response.data.code == 200){
        //             this.signImg = response.data.data.sign.image;
        //         }
        //     }, error => {
        //         console.log(error)
        //     });
        // })
    },
    //base64转化为file
    dataURLtoFile(dataurl, filename) {
        let arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    },
    dataURItoBlob(base64Data){
      var byteString;
      if (base64Data.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(base64Data.split(',')[1]);
      else
        byteString = unescape(base64Data.split(',')[1]);
      var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {type:mimeString});
    },
     clear(){
        var _this = this;
        _this.$refs.signature1.clear();
    },
    cancleDia(){
        this.showSign = false;
    },
  },
  components:{
    vueSignature
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dialog{
      width:100%;
      height:100%;
      background: rgba(0,0,0,0.6);
      z-index: 100;
      top:0;
      position: fixed;
      justify-content: center;
      align-items: center;
      display: flex;
      flex-direction: column;
  }
  .sign_btns{
    display: flex;
    flex-direction: row;
    margin-top:20px;
    justify-content: center;
    text-align: center;
  }
  .saveBtn{
      width:80px;
      height:30px;
      line-height:30px;
      color:white;
      background:#4367FD;
      border-radius:5px;
      font-size:13px;
  }
  .clearBtn{
      width:80px;
      height:30px;
      line-height:30px;
      color:white;
      background:#DA3807;
      border-radius:5px;
      font-size:13px;
      margin:0 10px;
  }
  .cancleBtn{
    width:80px;
    height:30px;
    line-height:30px;
    color:white;
    background:gray;
    border-radius:5px;
    font-size:13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Signature.vue